import { AutogenLayoutMiscInvoiceDetailTable } from "./autogen/AutogenLayoutMiscInvoiceDetailTable";
import { BlurEvent, DropdownSelectionEvent, LookupModelSelectionEvent, TableRow, Textbox } from "@mcleod/components";
import { Currency, CurrencySettings, ModelRow } from "@mcleod/core";

export class MiscInvoiceDetailTable extends AutogenLayoutMiscInvoiceDetailTable {
    private recalculating: boolean = false;
    currencyCode: string; // Used for multicurrency currency code when new charges are added.
    billDate: Date; // Used for multicurrency exchange rate when new charges are added.

    textboxChargeIdOnLookupModelSelection(event: LookupModelSelectionEvent) {
        const selectedRow = event.selection;
        const textbox = event.target as Textbox;
        if (selectedRow && textbox) {
            const tableRow = TableRow.getContainingTableRow(textbox);
            const modelRow: ModelRow = tableRow.data as ModelRow;
            if (modelRow) {
                modelRow.set("descr", selectedRow.getString("descr", ""));
                modelRow.set("charge_method", selectedRow.getString("charge_rate_method", ""));
                modelRow.set("rate", selectedRow.getNumber("amount", 0));
                modelRow.set("is_taxable", selectedRow.getString("is_taxable", "N"));
                this.recalculateAmount(tableRow, modelRow);
            }
        }
    }

    textboxChargeMethodAfterDropdownSelection(event: DropdownSelectionEvent) {
        const textbox = event.target as Textbox;
        const tableRow = TableRow.getContainingTableRow(textbox);
        const modelRow: ModelRow = tableRow.data as ModelRow;
        if (modelRow) {
            this.recalculateAmount(tableRow,modelRow);
        }
    }

    textboxChargeUnitsOnBlur(event: BlurEvent) {
        this.textboxOnBlur(event);
    }

    textboxRateOnBlur(event: BlurEvent) {
        this.textboxOnBlur(event);
    }

    textboxOnBlur(event: BlurEvent) {
        if (event.changedWhileFocused) {
            const textbox = event.target as Textbox;
            const tableRow = TableRow.getContainingTableRow(textbox);
            const modelRow: ModelRow = tableRow.data as ModelRow;
            if (modelRow) {
                this.recalculateAmount(tableRow, modelRow);
            }
        }
    }

    private recalculateAmount(tableRow: TableRow, modelRow: ModelRow) {
        if (this.recalculating) {
            return;
        }

        this.recalculating = true;
        try {
            const units = modelRow.getNumber("charge_units", 0);
            const rate = modelRow.getNumber("rate", 0);
            if (units != null && rate != null) {
                let amount = 0;
                const method = modelRow.getString("charge_method", "");
                if ("T" === method) { // Tons
                    amount = Number.parseFloat(((units * rate) / 2000).toFixed(2));
                } else if ("P" === method || "C" === method) { // Percentage or CWT
                    amount = Number.parseFloat(((units * rate) / 100).toFixed(2));
                } else { // Treat as Flat
                    amount = Number.parseFloat((units * rate).toFixed(2));
                }

                const currencyCode = this.currencyCode || CurrencySettings.getTransactionalCurrency();
                const conversionDate = this.billDate || new Date();
                const amountCurrency = new Currency({ amount, currency_code: currencyCode, conversion_date: conversionDate });
                modelRow.updateCurrency("amount", amountCurrency);
            }
        } finally {
            tableRow?.displayComponentValues();
            this.recalculating = false;
        }
    }

    updateMulticurrencyAmounts() {
        this.tableMiscInvoiceDetail.rows.forEach((tableRow) => {
            const modelRow: ModelRow = tableRow.data;
            if (modelRow && !modelRow.isNull("amount")) {
                const amount = modelRow.getCurrency("amount", new Currency(0));
                amount.setCurrencyCode(this.currencyCode || CurrencySettings.getTransactionalCurrency());
                amount.setConversionDate(this.billDate || new Date());
                modelRow.updateCurrency("amount", amount);
            }
        });
    }
}
